export const employeeExperienceTableConfig = [
  {
    field: 'slNo',
    header: 'Sl. No',
    align: 'right',
    filter: false,
    visible: true,
    defaultPinned: true,
    sortable: false,
    order: 1,
    menuItems: [],
  },
  {
    field: 'experienceRange',
    header: 'Experience Range',
    numeric: false,
    align: 'left',
    className: 'employee-experience-data-column',
    headerClassName: 'employee-experience-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 2,
    menuItems: [],
  },
  {
    field: 'status',
    header: 'Status',
    className: 'employee-experience-data-column',
    headerClassName: 'employee-experience-data-column',
    width: 180,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 3,
    menuItems: [],
  },
  {
    field: 'action',
    header: 'Action',
    className: 'employee-experience-data-column employee-experience-action-column',
    headerClassName: 'employee-experience-data-column employee-experience-action-column',
    width: 180,
    exportable: false,
    filter: false,
    visible: true,
    defaultPinned: false,
    sortable: false,
    order: 4,
    menuItems: [],
  },
];
